import React, { useEffect, useState } from "react";
import { useAuth } from "../../config/AuthContext";
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  replyContainer: {
    padding: theme.spacing(0),
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "start",
  },
  replierDetails: {
    color: theme.palette.text.disabled,
  },
}));

const Replies = ({ commentKey, blogKey }) => {
  const classes = useStyles();
  const { dbRef } = useAuth();
  const [repliesSnap, setRepliesSnap] = useState([]);
  let replies = [];

  useEffect(() => {
    const unsubscribe = dbRef
      .child(`blogs/${blogKey}/BlogComments/${commentKey}/BlogReplies/`)
      .on("value", (snapshot) => {
        setRepliesSnap(snapshot);
      });

    return unsubscribe;
  }, [blogKey, dbRef, commentKey]);

  repliesSnap.forEach((child) => {
    replies.push(child);
  });

  const replyList = replies.map((reply) => {
    return (
      <Typography
        variant="body1"
        className={classes.replierDetails}
        key={reply.key}
      >
        @{reply.val().Replier} : {reply.val().Reply}
      </Typography>
    );
  });
  return <div className={classes.replyContainer}>{replyList}</div>;
};

export default Replies;
